import React, { useEffect, useState } from "react";
import { Box, Grid, CircularProgress } from "@mui/material";
import HeadingComponent from "../../../../component/atom/Headings/Heading";
import { TextIconButtonComponent } from "../../../../component/atom";
import TableComponent from "../../../../component/atom/Table/TableComponent";
import DialogComponent from "../../../../component/atom/Dialog/Dialog";
import {
  AdminQuizForm,
  AdminQuizView,
  PopUpMessageComponent,
  AdminDocumentFolderAdd,
  DocumentAssociationDialog,
} from "../../../../component/molecule";
import Breadcrumbs from "../../../../component/molecule/Document/BreadCrumb";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { Actions } from "../../../../core/modules/Actions";
import { AdminQuizEdit } from "../../../../component/molecule/Forms";
import DropDownComponent from "../../../../component/atom/Inputs/DropDown";
import AdminQuizFolderMapping from "../../../../component/atom/Dialog/QuizSelection";
import GuestRepository from "../../../../core/repository/QuizeRepository";
import {
  DOCUMENT_STATUS,
  isFolder,
  normalizeQuizDirectoryData,
} from "../../../../core/Constant";
import { useFolderNavigation } from "../../../../hook/useFolderNavigation";
import AdminFolderEditModal from "../../../../component/molecule/Dialog/AdminFolderEditModal.jsx";
import { useQuizTableColumns } from "../../../../hook/useQuizTableColumns.jsx";
import { AddQuizFolderMenu } from "../../../../component/molecule/Cards/admin/AddQuizFolderMenu.jsx";
import { FolderActionConfirmationDialog } from "../../../../component/molecule/Dialog/FolderActionConfirmationDialog.jsx";
import { useNavigate, useLocation } from "react-router-dom";

const AdminQuizMainScreen = ({
  upDateQuizState,
  deleteQuize,
  getAllStateCourseList,
  getCourseList,
  courseList,
  upDateQuizFolderState,
  deleteQuizFolder,
  checkQuizAssociation,
  checkQuizDirectoryAssociation,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [addQuiz, setAddQuiz] = useState(false);
  const [viewQuiz, setViewQuiz] = useState(false);
  const [deleteQuiz, setDeleteQuiz] = useState(false);
  const [selectQuiz, setSelectedQuiz] = useState("");
  const [editQuiz, setEditQuiz] = useState(false);

  const [allQuiz, setAllQuiz] = useState([]);
  const [courseId, setCourseId] = useState(null);
  const [addFolder, setAddFolder] = useState(false);
  const [selectQuizDialog, setSelectQuizDialog] = useState(false);

  const [editFolderData, setEditFolderData] = useState(null);
  const [folderConfirm, setFolderConfirm] = useState(null);

  const [baseUrl, setBaseUrl] = useState("");
  const [quizAssociation, setQuizAssociation] = useState(null);

  const savedFolderId =
    location.state?.folderId ??
    JSON.parse(sessionStorage.getItem("quiz_active_folder_id") || "null");
  const savedCourseId =
    location.state?.courseId ??
    JSON.parse(sessionStorage.getItem("quiz_active_course_id") || "null");
  const savedBreadcrumbTrail =
    location.state?.breadcrumbTrail ??
    JSON.parse(sessionStorage.getItem("quiz_breadcrumb_trail") || "null");

  const getQuizTargetId = (doc) => (doc?.quiz_id ? doc.quiz_id : doc?.id);

  // Helper function to clear session storage
  const clearQuizSessionStorage = () => {
    sessionStorage.removeItem("quiz_active_folder_id");
    sessionStorage.removeItem("quiz_active_course_id");
    sessionStorage.removeItem("quiz_breadcrumb_trail");
  };

  // Helper function to save current navigation state to session storage
  const saveQuizSessionStorage = (folderIdVal, courseIdVal, breadcrumbTrailVal) => {
    sessionStorage.setItem("quiz_active_folder_id", JSON.stringify(folderIdVal));
    sessionStorage.setItem("quiz_active_course_id", JSON.stringify(courseIdVal));
    sessionStorage.setItem("quiz_breadcrumb_trail", JSON.stringify(breadcrumbTrailVal));
  };

  const fetchDocuments = async (parentId, selectedCourseId, search = "") => {
    const course =
      selectedCourseId === "All Courses" ||
      selectedCourseId === null
        ? null
        : Number(selectedCourseId);

    const activeSearch = search || "";

    const payload = {
      search: activeSearch,
      parent_id: parentId,
      course_id: course,
    };

    const response = await GuestRepository.onGetAllQuizList(payload);
    const apiData = response?.data || response;

    if (apiData?.base_url) {
      setBaseUrl(apiData.base_url);
    }

    const sortedData = normalizeQuizDirectoryData(
      apiData?.quiz_directories,
      apiData?.quizzes || apiData?.quiz
    );

    setAllQuiz(sortedData);
  };

  const {
    currentFolderId,
    setCurrentFolderId,
    setFolderStack,
    folderLoading,
    setFolderLoading,
    searchText,
    breadcrumbTrail,
    navigateToBreadcrumb: originalNavigateToBreadcrumb,
    openFolder: originalOpenFolder,
    handleSearch,
    setSearchText,
  } = useFolderNavigation(fetchDocuments, "Quiz");

  const openFolder = (folder) => {
    clearQuizSessionStorage();
    originalOpenFolder(folder, courseId);
  };

  // Fixed Breadcrumb Navigation
  const navigateToBreadcrumb = (index, item) => {
    clearQuizSessionStorage();
    typeof setSearchText === "function" && setSearchText("");

    if (index === 0 || item?.id === null) {
      setCurrentFolderId(null);
      setFolderStack([]);
      setFolderLoading(true);
      fetchDocuments(null, courseId, "").finally(() => {
        setTimeout(() => setFolderLoading(false), 300);
      });
      return;
    }

    if (typeof originalNavigateToBreadcrumb === "function") {
      originalNavigateToBreadcrumb(index, courseId);
    }
  };

  useEffect(() => {
    const initDataFetch = async () => {
      setFolderLoading(true);
      try {
        if (savedFolderId !== null) setCurrentFolderId(savedFolderId);
        if (savedCourseId !== null) setCourseId(savedCourseId);

        if (savedBreadcrumbTrail?.length) {
          const pureFolders = savedBreadcrumbTrail.filter(
            (item) => item.id !== null
          );
          setFolderStack(pureFolders);
        }

        await fetchDocuments(savedFolderId, savedCourseId, "");
        await Promise.all([getAllStateCourseList(), getCourseList()]);
      } catch (error) {
        console.error("Initial data load failed: ", error);
      } finally {
        setTimeout(() => setFolderLoading(false), 300);
      }
    };

    initDataFetch();
  }, []);

  const getDocumentById = (id) =>
    allQuiz.find((d) => String(d.id) === String(id));

  const onCourseChange = async (e) => {
    const val = e.target.value;
    const selectedCourseId =
      val === "All Courses" || val === null
        ? null
        : val;

    clearQuizSessionStorage();
    typeof setSearchText === "function" && setSearchText("");
    setCourseId(selectedCourseId);
    setCurrentFolderId(null);
    setFolderStack([]);

    setFolderLoading(true);
    try {
      await fetchDocuments(null, selectedCourseId, "");
    } finally {
      setTimeout(() => setFolderLoading(false), 500);
    }
  };

  const handleExecuteStatusUpdate = async (targetId) => {
    const doc = getDocumentById(targetId);
    if (!doc) return;

    const currentStatus = doc?.status;
    const newStatusBoolean =
      currentStatus == DOCUMENT_STATUS.ACTIVE
        ? DOCUMENT_STATUS.INACTIVE
        : DOCUMENT_STATUS.ACTIVE;

    const isDirectoryItem = isFolder(doc) || Boolean(doc?.quiz_id);

    if (isDirectoryItem) {
      const updateFn =
        upDateQuizFolderState || GuestRepository.onUpdateQuizFolderState;
      await updateFn({ quiz_id: doc.id, status: newStatusBoolean ? 1 : 0 });
    } else {
      await upDateQuizState({ quiz_id: doc.id, status: newStatusBoolean });
    }

    setAllQuiz((prev) =>
      prev.map((item) =>
        String(item?.id) === String(targetId)
          ? { ...item, status: newStatusBoolean ? 1 : 0 }
          : item
      )
    );
  };

  const statusUpdate = (tableMeta) => {
    const targetId = tableMeta?.rowData[0];
    const doc = getDocumentById(targetId);

    if (doc && isFolder(doc)) {
      setFolderConfirm({
        type: "status",
        id: targetId,
        tableMeta,
        understood: false,
      });
    } else {
      handleExecuteStatusUpdate(targetId);
    }
  };

  const showQuizDeleteConfirmation = (doc) => {
    setSelectedQuiz(doc.id);
    setDeleteQuiz(true);
  };

  const checkAssociationBeforeAction = async (doc, action) => {
    if (!doc?.id || isFolder(doc)) return false;

    const isUnassigned = Number(doc.is_unassigned) === 1;
    const associationId = isUnassigned
      ? getQuizTargetId(doc)
      : doc.id;
    const checkAssociation = isUnassigned
      ? checkQuizAssociation
      : checkQuizDirectoryAssociation;

    if (!checkAssociation || !associationId) return false;

    const response = await checkAssociation(associationId);
    if (response?.error) return false;

    const associationData = response && Object.prototype.hasOwnProperty.call(response, "data")
      ? response.data?.data ?? response.data
      : response;
    if (associationData?.is_associated !== true) return false;

    const hasAssociationData = Array.isArray(associationData)
      ? associationData.length > 0
      : associationData && typeof associationData === "object"
        ? Object.keys(associationData).length > 0
        : Boolean(associationData);

    if (!hasAssociationData) return false;

    setQuizAssociation({
      data: associationData,
      message: response?.message,
      entityName: doc.name || doc.quiz_name,
      entityType: "quiz",
      document: doc,
      action,
    });
    return true;
  };

  const onPressDelete = async (tableMeta) => {
    const targetId = tableMeta.rowData[0];
    const doc = getDocumentById(targetId);

    if (doc && isFolder(doc)) {
      setFolderConfirm({ type: "delete", id: targetId, understood: false });
    } else {
      if (await checkAssociationBeforeAction(doc, "delete")) return;
      showQuizDeleteConfirmation(doc);
    }
  };

  const continueQuizAction = () => {
    const pendingAction = quizAssociation;
    setQuizAssociation(null);
    if (!pendingAction?.document) return;

    if (pendingAction.action === "delete") {
      showQuizDeleteConfirmation(pendingAction.document);
    } else {
      openQuizEdit(pendingAction.document);
    }
  };

  const openQuizEdit = (doc) => {
      const actualQuizId = getQuizTargetId(doc);

      saveQuizSessionStorage(currentFolderId, courseId, breadcrumbTrail);

      navigate("/admin-quiz-edit-first", {
        state: {
          id: actualQuizId,
          quizData: doc,
          folderId: currentFolderId,
          courseId: courseId,
          breadcrumbTrail: breadcrumbTrail,
        },
      });
    };

    const onEditPress = async (tableMeta) => {
      const tableRowId = tableMeta.rowData[0];
      const doc = getDocumentById(tableRowId);

      if (!doc) return;

      if (isFolder(doc)) {
        setEditFolderData(doc);
      } else {
        if (await checkAssociationBeforeAction(doc, "edit")) return;
        openQuizEdit(doc);
    }
  };

  const confirmFolderAction = async () => {
    if (!folderConfirm) return;

    if (folderConfirm.type === "status") {
      await handleExecuteStatusUpdate(folderConfirm.id);
    } else if (folderConfirm.type === "delete") {
      const deleteFn = deleteQuizFolder || GuestRepository.onDeleteQuizFolder;
      await deleteFn(folderConfirm.id);
      fetchDocuments(currentFolderId, courseId, searchText);
    }
    setFolderConfirm(null);
  };

  const onDeleteQuize = async () => {
    const doc = getDocumentById(selectQuiz);
    if (!doc) {
      onDeleteClose();
      return;
    }

    const isDirectoryMapping = Boolean(doc?.quiz_id);

    if (isDirectoryMapping) {
      const deleteFn = deleteQuizFolder || GuestRepository.onDeleteQuizFolder;
      await deleteFn(doc.id);
    } else {
      await deleteQuize(doc.id);
    }

    onDeleteClose();
    fetchDocuments(currentFolderId, courseId, searchText);
  };

  const onDeleteClose = () => {
    setDeleteQuiz(false);
    setSelectedQuiz("");
  };

  const onViewBtn = (tableMeta) => {
    const tableRowId = tableMeta.rowData[0];
    const doc = getDocumentById(tableRowId);

    if (!doc) return;

    const actualQuizId = getQuizTargetId(doc);

    saveQuizSessionStorage(currentFolderId, courseId, breadcrumbTrail);

    navigate('/admin-quiz-view', {
      state: {
        id: actualQuizId,
        quizData: doc,
        folderId: currentFolderId,
        courseId: courseId,
        breadcrumbTrail: breadcrumbTrail,
        baseUrl: baseUrl,
      },
    });
  };

  const columns = useQuizTableColumns({
    allQuiz,
    folderLoading,
    courseId,
    openFolder,
    onViewBtn,
    onEditPress,
    onPressDelete,
    statusUpdate,
  });

  return (
    <>
      {/* FULL PAGE OVERLAY LOADER */}
      {folderLoading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress sx={{ color: "#9834F0" }} size={60} />
        </Box>
      )}

      <Box className="main-screen-container">
        <Grid container direction="row" justifyContent="space-between">
          <Grid item>
            <HeadingComponent
              text={"Quizzes"}
              fontweigth={600}
              size={40}
              fontfamily={"Montserrat"}
            />
          </Grid>

          <Grid item className="student-search-btn-section" columnGap={2}>
            <Box className="student-search-btn-inner-section"
              sx={{ minWidth: "220px", width: { xs: "100%", lg: "350px" } }}
            >
              <DropDownComponent
                list={courseList}
                initialValue={"All Courses"}
                selectedValue={courseId ?? 0}
                radius={"15px"}
                onchange={onCourseChange}
                placeholder={"All Courses"}
                fixedWidth="100%"
                enableTooltip={true}
              />
            </Box>
            <AddQuizFolderMenu
              onCreateFolderClick={() => setAddFolder(true)}
              onCreateQuizClick={() => {
                saveQuizSessionStorage(currentFolderId, courseId, breadcrumbTrail);
                navigate("/admin-quiz-first", {
                  state: {
                    folderId: currentFolderId,
                    courseId: courseId,
                    breadcrumbTrail: breadcrumbTrail,
                  },
                });
              }}
              onSelectQuizClick={() => setSelectQuizDialog(true)}
            />
            <TextIconButtonComponent
              btnText={"View Submission"}
              icon={faEye}
              onclick={() => navigate("/admin-submission-history")}
            />
          </Grid>
        </Grid>

        <Box className="common-admin-content-wrap">
          {breadcrumbTrail.length > 1 && (
            <Breadcrumbs
              breadcrumbTrail={breadcrumbTrail}
              onBreadcrumbClick={(index, item) =>
                navigateToBreadcrumb(index, item)
              }
            />
          )}

          <TableComponent
            key={`${currentFolderId}-${courseId}`}
            columns={columns}
            data={allQuiz}
            filter={false}
            onSearchChange={(val) => handleSearch(val, courseId)}
            rowsPerPage={10}
          />
        </Box>
      </Box>

      {/* Edit Folder Dialog */}
      <DialogComponent
        isShowCloseButton={true}
        title="EDIT FOLDER"
        open={Boolean(editFolderData)}
        maxwidth="sm"
        onClose={() => setEditFolderData(null)}
      >
        <AdminFolderEditModal
          folder={editFolderData}
          baseUrl={baseUrl}
          onClose={() => setEditFolderData(null)}
          onSuccess={() => {
            setEditFolderData(null);
            fetchDocuments(currentFolderId, courseId, "");
          }}
        />
      </DialogComponent>

      {/* Quiz delete popup */}
      <PopUpMessageComponent
        open={deleteQuiz}
        type={"other"}
        title={"DELETE!"}
        message={"Are you sure you want to delete quiz?"}
        btntext={"Yes, delete"}
        altbtntext={"No"}
        onclick={onDeleteQuize}
        altonclick={onDeleteClose}
        onclose={onDeleteClose}
      />

      <FolderActionConfirmationDialog
        folderConfirm={folderConfirm}
        setFolderConfirm={setFolderConfirm}
        onConfirm={confirmFolderAction}
      />

      <DocumentAssociationDialog
        association={quizAssociation}
        onClose={() => setQuizAssociation(null)}
        onConfirm={continueQuizAction}
      />

      <AdminQuizForm open={addQuiz} onClose={() => setAddQuiz(false)} />
      <DialogComponent
        isShowCloseButton={true}
        title={"View Quiz"}
        open={viewQuiz}
        onClose={() => setViewQuiz(false)}
      >
        <AdminQuizView onClose={() => setViewQuiz(false)} />
      </DialogComponent>

      <DialogComponent
        isShowCloseButton={true}
        title={"Edit Quiz"}
        open={editQuiz}
        onClose={() => setEditQuiz(false)}
      >
        <AdminQuizEdit onClose={() => setEditQuiz(false)} />
      </DialogComponent>

      <DialogComponent
        isShowCloseButton={true}
        title={"CREATE FOLDER"}
        open={addFolder}
        maxwidth="sm"
        onClose={() => setAddFolder(false)}
      >
        <AdminDocumentFolderAdd
          key={addFolder ? "quiz-folder-open" : "quiz-folder-closed"}
          courseId={courseId}
          parent_id={currentFolderId}
          useQuizRoute={true}
          existingItems={allQuiz}
          onClose={() => {
            setAddFolder(false);
            fetchDocuments(currentFolderId, courseId, "");
          }}
        />
      </DialogComponent>

      <DialogComponent
        open={selectQuizDialog}
        title="ADD QUIZ TO FOLDER"
        maxwidth="sm"
        isShowCloseButton={true}
        onClose={() => setSelectQuizDialog(false)}
      >
        <AdminQuizFolderMapping
          folderId={currentFolderId}
          quizList={allQuiz.filter((item) => !isFolder(item))}
          onClose={() => setSelectQuizDialog(false)}
          onSuccess={() =>
            fetchDocuments(currentFolderId, courseId, "")
          }
        />
      </DialogComponent>
    </>
  );
};

export default connect(
  (state) => ({
    quizList: state.quizes.get("quizList"),
    courseList: state.students.get("commonCourseList"),
  }),
  {
    getQuizeList: Actions.quizes.getQuizeList,
    upDateQuizState: Actions.quizes.upDateQuizState,
    getQuizById: Actions.quizes.getQuizById,
    deleteQuize: Actions.quizes.deleteQuize,
    verifyToken: Actions.auth.verifyToken,
    getAllStateCourseList: Actions.course.getAllStateCourseList,
    getCourseList: Actions.quizes.getCourseListByQuiz,
    deleteQuizFolder: Actions.quizes.deleteQuizFolder,
    upDateQuizFolderState: Actions.quizes.upDateQuizFolderState,
    checkQuizAssociation: Actions.quizes.checkQuizAssociation,
    checkQuizDirectoryAssociation: Actions.quizes.checkQuizDirectoryAssociation,
  }
)(AdminQuizMainScreen);
